// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import VueCookies from 'vue-cookies';
import VueLazyload from 'vue-lazyload';
import Vue2TouchEvents from 'vue2-touch-events';
import router from './router';
import store from './store/index';
import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-client';
import {HttpLink} from 'apollo-link-http';
import {ApolloLink} from 'apollo-link';
import {InMemoryCache, IntrospectionFragmentMatcher} from 'apollo-cache-inmemory';
import introspectionQueryResultData from './apollo/fragmentTypes.json';
import { i18n } from './plugins/i18n.js';
import VueMatomo from 'vue-matomo';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
});

const httpLink = new HttpLink({
  uri: 'https://zeigdeinprodukt.de/backend/graphql',
  // uri: 'https://dev-zeig-dein-produkt-9.pantheonsite.io/graphql',
  headers: {
    authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjM2NDhiM2ZlOTFmMzkyODdiZjVlZmRkYjgyODBkM2E1MjJkNTAxMWM0NzM2OTMxY2QwYWVhMzU2ZmUzYzE2ZTMxNGRiYjdlYTA4NzBmNjgxIn0.eyJhdWQiOiI5MTBlODgwOC00ZjlmLTQ1Y2ItOGM2Zi04ODRmODAxNGNkNzIiLCJqdGkiOiIzNjQ4YjNmZTkxZjM5Mjg3YmY1ZWZkZGI4MjgwZDNhNTIyZDUwMTFjNDczNjkzMWNkMGFlYTM1NmZlM2MxNmUzMTRkYmI3ZWEwODcwZjY4MSIsImlhdCI6MTc2OTUyNzYyNiwibmJmIjoxNzY5NTI3NjI2LCJleHAiOjE4MDEwNjM2MjYsInN1YiI6IjY0Iiwic2NvcGVzIjpbImF1dGhlbnRpY2F0ZWQiLCJncmFwaHFsIl19.IHwZsfrJ2I9xINsmQ5VVlB2R2O_7pbWmaoyNK-vmLwCNK-g2_bROoAMTdnPIfw1vNXKDiTwzY0kkzFa9eE9ce99qtGqsZKXgEJ1cVRwEy6qiauHP_SHnZ2E4e3wwJG0ivQhsPmI2IbTfNWEkWInAVRvcGxC6asvCpZuFGVjpSh6WDC-12WGXLcDtcILuTpMCyOkJ8zt55SjLqDDnsGYCkd7eHy_ro_oeozYb0ujupgjqATw7g7C-2_s7zFREtVyXsUU5wuoP0z54Dz5Y1dTbNUQmbTrbpdE0jJMNnER7i0WrvxOrNweo1x-8vJll0890O10R4oe1W21Lukni7Ve3xBvtKZvExhFSur7Yjo38f6Ne4PVlqknpAUz0QHtGkOI32RzcHubnilrituRUowZtDwJ2wW16Uk_MwGFmJi-_nysYFiL6AijFay8TK_jQYbs_UOww6dfGlBCJoHmQObrKXWMAbe-k8lIyRIkt7ceAceJhjE8ygxuoRLxEt5nQMiLCVH4lkzu79RnxIbxymcEkc13yJDfNn-0VFVMTl9x2-JVO6sJNXPXHgOOkWXUxDtQFxzIxInHEjxss_v8aiN0XeovqTDQQ5vgMUMymJWZ8hjXSGP51zMoUL_ySJ4H1ZZqwgjZb0MAwXNRwY9hwoD5DDePnbz_X04UVryFumoynN4s`
  }
});

const middlewareLink = new ApolloLink((operation, forward) => {
  operation.setContext({});
  return forward(operation);
});

const link = middlewareLink.concat(httpLink);

const apolloClient = new ApolloClient({
  link: link,
  cache: new InMemoryCache({fragmentMatcher}),
  defaultHttpLink: false,
});

Vue.config.productionTip = false;

Vue.use(VueApollo);
Vue.use(VueLazyload);
Vue.use(Vue2TouchEvents);
Vue.use(VueCookies);
Vue.use(VueMatomo, {
  host: 'https://zeigdeinprodukt.de/matomo',
  siteId: 1,
  router: router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: true,
  debug: false,
});

// Disable VueWarn printing
Vue.config.warnHandler = function(msg, vm, trace) {};

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  apolloProvider,
  router,
  i18n,
  components: { App },
  template: '<App/>'
});
